import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { message, Modal } from 'antd';
import { WeaSelectOptionProps } from '../../../stores/mobxTable/table';
import _ from 'lodash';
import { WeaSelect, WeaInput, WeaLocaleProvider } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

interface Props {
    value?: string;
    editable?: boolean;
    options?: WeaSelectOptionProps[];
    column?;
    onChange?;
    row?;
    tableStore?;
    secretTimeDefValue?;
}
@observer
export default class Main extends React.Component<Props,any>{
    getOptions=()=>{
        const {options} = this.props;
        let optionArr:any = [];
        options&&options.map(opt => {
            optionArr.push({
                key: opt.key,
                showname: opt.showname
            });
        });
        return optionArr;
    }
    render(){
        const props = this.props;
        const filered = props.options && props.options.filter(d => props.value ? d.key == props.value : d.selected);
        let value = props.value;
        let showname = '';
        let {column,row}=props;
        if(column.detailtype!=2){
            if (filered && filered.length > 0) {
                value = _.get(filered, '[0].key');
                showname = _.get(filered, '[0].showname');
            } else {
                value = '';
            }
        }
        let hide=column&&column.isHide&&column.isHide(row);
        const valueSpan = row.value[column.key+'span']&&row.$(column.key+'span').value;
        const valueDesc=column.valueDesc&&column.valueDesc(value,row);
        const isHighSecLevel = value&&['1','2'].indexOf(value)>-1; // 是否显示保密期限字段
        const modeSecritTimeValue = row.has('modesecrettime')?row.$('modesecrettime').value:'';
        return (
            <div style={hide?{display:"none"}:{display:"block"}}>
            {props.editable ?
                (<Fragment ecId={`${this && this.props && this.props.ecId || ''}_Fragment@gqodqd`}>
                    <WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@5r51zo`} 
                        {...props}
                        detailtype={column.detailtype}
                        options={this.getOptions()}
                        value={value}
                        viewAttr={3}
                        onChange={this.handleChange}
                        style={column.width?{maxWidth:column.width,width:isHighSecLevel?70:"100%"}:{width:isHighSecLevel?70:"100%"}}
                        supportCancel
                    />
                    {
                        isHighSecLevel&&(
                            <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@7aljcm`}
                                helpfulTip={getLabel('528340','保密期限填写格式：3个月、10年、20年、长期…不能是纯数字')}
                                // helpfulTipProps={{style:{position: "absolute", right: -20, top: 4}}}
                                value={modeSecritTimeValue}
                                style={{paddingLeft:3,width: 70}}
                                viewAttr={3}
                                onChange={this.handleChangeSecretTime}
                                onBlur={this.handleInputBlur}
                            />
                        )
                    }
                </Fragment>) : <span>{valueDesc||valueSpan||showname}</span>}
            </div>
        )
    }

    handleChange = (v) => {
        let { value, tableStore, row } = this.props;
        if (value && (value < v || v=='')) { // 高密级切换低密级，需清除数据
            const mythis = this;
            const randomkey = row.key ? row.key.toString().split("_")[0] : "";
            const _modesecrettime = row.$('modesecrettime').value;
            Modal.confirm({
                title: getLabel('131329','信息确认'),
                content: getLabel('530633','变更密级，高于当前卡片密级的关联资源会被清除，附件密级将自动调整为修改的密级，确定要调整吗？'),
                onOk() {
                    /* 降低密级，清空数据 */
                    row.clearRowFields();
                    tableStore.oldDataRecord = _.filter(tableStore.oldDataRecord, item=>item.randomFieldId!=randomkey);
                    mythis.changeSeclevelValue(v);
                },
                onCancel() {
                    mythis.changeSeclevelValue(value, _modesecrettime);
                }
            });
        }
        this.changeSeclevelValue(v);
    }
    changeSeclevelValue = (key, _modesecrettime?) => {
        let { column, row, onChange, secretTimeDefValue } = this.props;
        onChange&&onChange(key);
        column.onChange&&column.onChange(key,row);
        const modeSecretTimeField = row.$('modesecrettime');
        if (_modesecrettime) {
            modeSecretTimeField.onChange(_modesecrettime);
        } else {
            switch(key) {
                case '1': modeSecretTimeField.onChange(secretTimeDefValue[key]);break;
                case '2': modeSecretTimeField.onChange(secretTimeDefValue[key]);break;
                default: modeSecretTimeField.onChange('');break;
            }
        }
    }
    handleChangeSecretTime = (value) => {
        let { row } = this.props;
        const modeSecretTimeField = row.$('modesecrettime');
        modeSecretTimeField.onChange&&modeSecretTimeField.onChange(value);
    }
    handleInputBlur = (v) => {
        let { row } = this.props;
        const modeSecretTimeField = row.$('modesecrettime');
        if (/^\d+$/.test(v)) {
            message.error(getLabel('530634','保密期限不能是纯数字'));
            modeSecretTimeField.onChange&&modeSecretTimeField.onChange('');
        }
        if (!v) {
            message.error(getLabel('530064','请填写保密期限'));
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/mobx-table/table-cell/Seclevel.tsx